import styled from 'styled-components';
import { breakPoints } from '~/styles/break-points';

export const StyledInformationSection = styled.section<{ imageUrl?: string | null }>`
	display: grid;
	gap: 48px;
	${({ imageUrl }) =>
		imageUrl
			? breakPoints({
					'768': `
			grid-template-columns: repeat(2, 1fr);
		`,
				})
			: ''}
`;

export const StyledDialogActionButtonWrapper = styled.div`
	width: 100%;

	${breakPoints({
		'1024': `
			width: fit-content;
		`,
	})}
`;
